<template>
  <footer id="footer">
    <b>© {{ actualYear }} Air Europa Líneas Aéreas S.A.U.</b> <br />
    Ctra. Arenal - Llucmajor, km.21,5 - 07620 Llucmajor · Baleares · España
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  computed: {
    actualYear() {
      return new Date().getFullYear(); // returns the current year
    },
  },
};
</script>

<style scoped>
#footer {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  bottom: 0px;
  width: 100%;
  line-height: 20px;
  background-color: #2d69e1;
  text-align: center;
  color: white;
  font-size: 14px;
  padding-top: 20px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 24px;
  margin: 0 auto;
  max-height: 116px;
}
</style>
